export default __webpack_public_path__ + "static/media/ADNOCIcon.69a34b0a.svg";